module.exports = __webpack_public_path__ + "media/images/brand-hero-fcb42db8388a9a8ce51f2f633bdf763b.svg";